<template>
  <span :class="classes">
    <span
      v-for="i in 3"
      :key="i"
      class="cordel-loading-bullet"
    />
  </span>
</template>

<script>
  export default {
    name: 'CordelContextLoading',
    props: {
      light: {
        type: Boolean,
        default: false,
        required: false,
      },
    },
    computed: {
      classes() {
        return {
          'cordel-loading': true,
          'variant--light': this.light,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-loading {
    --loading-bullet: var(--cordel-legacy-spacing-mini);
    --loading-margin: var(--loading-bullet);

    height: calc(var(--loading-bullet) * 2);
    position: relative;
    width: calc(var(--loading-bullet) * 3 + var(--loading-margin) * 2);
  }

  @keyframes loading {
    0% { transform: translateY(calc(var(--loading-bullet) / -2)); opacity: 1; }
    50% { transform: translateY(var(--loading-bullet) / 2); opacity: 0.5; }
    100% { transform: translateY(calc(var(--loading-bullet) / -2)); opacity: 1; }
  }

  .cordel-loading-bullet {
    animation: loading 1s infinite;
    background-color: var(--cordel-legacy-color-neutral-primary);
    border-radius: 100%;
    height: var(--loading-bullet);
    left: 0;
    position: absolute;
    top: calc(50% - var(--loading-bullet) / 4);
    width: var(--loading-bullet);

    .variant--light & {
      background-color: var(--cordel-legacy-color-constant-light);
    }

    @for $i from 0 through 2 {
      &:nth-child(#{$i}) {
        animation-delay: $i * 0.2s;
        left: calc((var(--loading-bullet) + var(--loading-margin)) * $i);
      }
    }
  }
</style>
